export default __webpack_public_path__ + "static/media/button_kikan-WEEK.1a584b0c.PNG";